import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface SidebarState {
  isOpen: boolean;
  isMobileMenuOpen: boolean;
  openMenuKey: string | null;
  toggleSidebar: () => void;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleMobileMenu: () => void;
  closeMobileMenu: () => void;
  setOpenMenuKey: (menuKey: string | null) => void;
  clearOpenMenuKey: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  devtools(
    persist(
      (set) => ({
        isOpen: true,
        isMobileMenuOpen: false,
        openMenuKey: null,

        toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),

        openSidebar: () => set({ isOpen: true }),

        closeSidebar: () => set({ isOpen: false }),

        toggleMobileMenu: () => set((state) => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),

        closeMobileMenu: () => set({ isMobileMenuOpen: false }),

        setOpenMenuKey: (menuKey: string | null) => set({ openMenuKey: menuKey }),

        clearOpenMenuKey: () => set({ openMenuKey: null }),
      }),
      {
        name: 'sidebar-store',
        partialize: (state) => ({ openMenuKey: state.openMenuKey }),
      }
    ),
    { name: 'SidebarStore' }
  )
);
